import React from "react";
import ProductSynthesis from "./Synthesis";
import ProductGallery from "./Gallery";
import EnhanceProductView from "./EnhanceProductView";

import {
  ProductSliderDesktop,
  ProductSliderMobile,
} from "theme/components/organisms/ProductSlider";
import IsDesktop from "theme/utils/isDesktop";
import { FormattedMessage } from "react-intl";

const ProductView = (props) => {
  const { product } = props;
  let sizeGuideCms = props.productSizeGuideSlipper;
  if (product.attributeSetId !== 4) {
    sizeGuideCms = "";
  }
  return (
    <div className="product">
      <div className="product__wrapper">
        <div className="product__container">
          <ProductGallery
            sku={product.sku}
            stickers={product.stickers}
            isNew={product.isNew}
            selectedSku={props.selectedSku}
            previewMainImageUrl={props.previewContent.image}
            src={product.imageUrl}
            images={product.images || []}
            adult_image={product.adult_image}
            name={product.name}
            visibleItems={3}
          />
        </div>
        <ProductSynthesis
          sizeGuideCms={sizeGuideCms}
          product={product}
          name={product.name}
          sku={product.sku}
          prices={product.prices}
          options={product.options}
          customOptions={product.custom_options}
          selectedOptions={props.selectedOptions}
          selectedCustomOptions={props.selectedCustomOptions}
          setOption={props.setOption}
          setCustomOption={props.setCustomOption}
          setSelectedOptions={props.setSelectedOptions}
          onProductAdded={() => {
            props.setSelectedOptions({});
            props.onProductAdded(product);
          }}
          stock={product.stock}
          additionalInformation={product.additionalInformation}
          setPreviewContent={props.setPreviewContent}
          previewContent={props.previewContent}
          intl={props.intl}
        />
      </div>

      {props.product.related && props.product.related.length > 0 && (
        <IsDesktop>
          {(isDesktop) => {
            return isDesktop ? (
              <ProductSliderDesktop
                title={
                  <FormattedMessage
                    id="modules.ProductView.UpsellTitle"
                    defaultMessage="Similar products"
                  />
                }
                headingLevel="h5"
                products={props.product.related}
              />
            ) : (
              <ProductSliderMobile
                title={
                  <FormattedMessage
                    id="modules.ProductView.UpsellTitle"
                    defaultMessage="Similar products"
                  />
                }
                headingLevel="h5"
                products={props.product.related}
              />
            );
          }}
        </IsDesktop>
      )}
    </div>
  );
};

export default EnhanceProductView()(ProductView);
